export default __webpack_public_path__ + "static/Chemistry_Bench-1beba8c0db6fac8550252cc1aa5db050.png";